import { render, staticRenderFns } from "./ParentRouteKeep.vue?vue&type=template&id=5a65996b&"
import script from "./ParentRouteKeep.vue?vue&type=script&lang=ts&"
export * from "./ParentRouteKeep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports